/**
 * Lightweight dynamic asset loader for perf (select2 on cart, model-normalize on demand).
 */
(function (window) {
  'use strict';

  var pending = Object.create(null);

  function loadScript(url) {
    if (!url) return Promise.reject(new Error('missing script url'));
    if (pending[url]) return pending[url];
    pending[url] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + url + '"]');
      if (existing) {
        if (existing.dataset.aiooLoaded === '1') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }
      var s = document.createElement('script');
      s.src = url;
      s.defer = true;
      s.onload = function () {
        s.dataset.aiooLoaded = '1';
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return pending[url];
  }

  function loadStylesheet(url) {
    if (!url) return Promise.resolve();
    if (document.querySelector('link[rel="stylesheet"][href="' + url + '"]')) {
      return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = url;
      l.onload = resolve;
      l.onerror = reject;
      document.head.appendChild(l);
    });
  }

  window.aiooLoadScript = loadScript;

  window.aiooEnsureSelect2 = function () {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
      return Promise.resolve();
    }
    var assets = window.AIOO_ASSETS || {};
    return loadStylesheet(assets.select2Css).then(function () {
      return loadScript(assets.select2Js);
    });
  };

  window.aiooEnsureModelNormalize = function () {
    if (typeof window.AIOO_modelsMatch === 'function') {
      return Promise.resolve();
    }
    var assets = window.AIOO_ASSETS || {};
    return loadScript(assets.modelNormalize);
  };
})(window);
